const I18n = {
  currentLocale: "ru",
  t(key) {
    let ts = I18n.translations[I18n.currentLocale];
    let missing = false;
    key.split(".").forEach(k => {
        if (missing) {
          return;
        }
        if (!ts.hasOwnProperty(k)) {
          missing = true;
          return;
        }
        ts = ts[k];
    });
    if (missing) {
      console.log(`missing translation for ${key}`);
      return key;
    } else if (typeof ts !== "string") {
      console.log(`missing translation for ${key}: not a string`, ts);
      return key;
    } else {
      return ts;
    }
  },
  translations: {
    ru: {
      jstest: {
        nested: {
          "foo": "bar"
        }
      },
      audio_player: {
        half_speed: "Замедлить"
      },
      login_page: {
        title: "Вход",
        text: "Войдите с помощью одной из социальных сетей, чтобы сохранить результат.",
        skip: "Не хочется, просто покажите мне результат"
      },
      test_wizard: {
        previous: "Назад",
        next: "Вперед",
        submit: "Готово!",
        question: "Вопрос",
        answer_options: "Варианты ответов",
        back: "Другой тест",
        errors: {
          generic_error: "Произошла ошибка. Пожалуйста, попробуйте чуть позже",
          failed_to_grade: "Ой! Произошла ошибка. Пожалуйста, попробуйте еще раз, чуть позже.",
          failed_to_persist: "Ой! Произошла ошибка. Пожалуйста, попробуйте еще раз, чуть позже."
        }
      },
      test_results: {
        title: "Результаты теста",
        score: "Ваш результат",
        public_url: "Ссылка на результат для ВКонтакте",
        back: "Другой тест",
        another: "Еще раз",
        is_correct_answer: "Правильный ответ",
        is_selected_answer: "Ваш ответ",
        question: "Вопрос"
      },
      userbar: {
        header: "Юзербар для форума",
        text: "Если вы хотите получить результаты в виде юзербара, чтобы показать другим — введите ваш e-mail и мы отправим его вам на указанный адрес",
        sent: "Юзербар отправлен на",
        will_send_to: "Юзербар будет отправлен на",
        different_email: "другой email",
        send: "Получить юзербар!",
        errors: {
          generic_error: "Произошла ошибка. Попробуйте еще раз.",
          save_email_failed: "Произошла ошибка. Попробуйте еще раз.",
          send_userbar_failed: "Произошла ошибка. Попробуйте еще раз.",
          email: {
            must_not_be_empty: "Email не может быть пустым"
          },
          userbar_token: {
            must_not_be_empty: "Не удалось сгенерировать юзербар"
          }
        }
      },
      edit_question_form: {
        text: "Текст вопроса",
        answers: "Варианты ответов",
        answer_placeholder: "Текст ответа",
        remove_answer: "Убрать",
        add_answer: "Добавить ответ",
        save: "Сохранить Вопрос",
        remove: "Удалить Вопрос",
        errors: {
          text: {
            must_not_be_empty: "Не может быть пустым"
          },
          answers: {
            must_have_at_least_one_correct_answer: "Нужно указать правильный ответ",
            must_have_at_least_2: "Нужно хотя бы два ответа",
            text: {
              must_not_be_empty: "Не может быть пустым"
            }
          }
        }
      },
      bulk_question_form: {
        submit:                        "Добавить вопросы",
        required:                      "обязательное поле",
        question_template:             "Текст вопроса",
        question_template_placeholder: "Вопрос...",
        answer_options:                "Варианты ответов",
        answer_option_placeholder:     "Ответ...",
        add_answer_option:             "Добавить ответ",
        remove_answer_option:          "Убрать",
        drop_here:                     "Перетащите файлы сюда",
        files:                         "Файлы",
        table: {
          filename:     "Имя файла",
          player:       "Плеер",
          answer:       "Ответ",
          remove_file:  "Убрать"
        },
        errors: {
          question_template: {
            must_not_be_empty: "Не может быть пустым",
          },
          answer_options: {
            must_have_at_least_2: "Нужно хотя бы 2",
            text: {
              must_not_be_empty: "Не может быть пустым"
            }
          },
          files: {
            must_have_at_least_1: "Нужен хотя бы один файл",
            must_select_answer_option: "Нужно выбрать ответ"
          }
        }
      },
      topics_list: {
        table: {
          headers: {
            name: "Название",
            level_name: "Уровень",
            questions_count: "Вопросы",
            published: "Опубликован",
            featured: "\"Новый\""
          },
          actions: {
            edit: "Изменить",
            add_questions: "Добавить вопросы",
            list_questions: "Список вопросов",
            destroy: "Выпилить"
          }
        }
      },
      profile_dashboard: {
        title: "Статистика по тестам",
        back: "← Назад к тестам",
        table: {
          test: "Тест",
          attempts: "Количество попыток",
          progress: "Прогресс"
        }
      },
      time_zone_selector: {
        header: "Часовой пояс"
      },
      login_dropdown: {
        title: "Войти",
        vk: "ВКонтакте",
        google_plus: "Google+"
      }
    }
  }
};

module.exports = I18n;



// WEBPACK FOOTER //
// ./app/javascript/helpers/I18n.js